import React from "react";

import DatasetLineChart from "components/dashboard/charts/dataset-line-chart/DatasetLineChart";
import { Dialog } from "primereact/dialog";
import useDatasetIdentifiersStore from "store/dataset-identifiers-store";
import useChartDialogStore from "store/chart-dialog-store";

const EasasGlobalChartDialog: React.FC = () => {
	const selectedIds = useDatasetIdentifiersStore(state => state.ids);
  const { isOpen, closeDialog, refTime } = useChartDialogStore();

	return <Dialog
	header='SCADA tags chart'
	visible={isOpen}
	style={{ width: 'min(100vw, 1000px)', height: '500px' }}
	modal={false}
	resizable
	draggable
	maximizable
	onHide={closeDialog}>
	<DatasetLineChart
		identifiers={[...selectedIds]}
		referenceTime={refTime}
		showDateSelection
		dynamicHeight
		chartDialogOpen={isOpen}
	/>
</Dialog>;
}

export default EasasGlobalChartDialog;